import {SourcingSuspiciousReason} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/**
 * Joins the suspiciousReason codes of a vehicle into a single human readable label.
 *
 * The codes come from the data pipeline and the data team extends the list over time, so the
 * labels live in their own `entity.sourcing.suspiciousReason.*` namespace instead of the generic
 * `entity.vehicle.labels.*` one.
 */
export function getSuspiciousReasonsLabel(
  reasons: SourcingSuspiciousReason[] | Nullish
): string | undefined {
  if (!reasons?.length) {
    return undefined;
  }

  return reasons.map((reason) => i18n.t(`entity.sourcing.suspiciousReason.${reason}`)).join(', ');
}
